import { render, staticRenderFns } from "./Faltan.vue?vue&type=template&id=913e8296&scoped=true"
import script from "./Faltan.vue?vue&type=script&lang=js"
export * from "./Faltan.vue?vue&type=script&lang=js"
import style0 from "./Faltan.vue?vue&type=style&index=0&id=913e8296&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913e8296",
  null
  
)

export default component.exports